export default function getImage(fileName: string, format?: string) {
  return `/images/${fileName}.${format ?? "png"}`;
}
